import { LinkOutlined } from '@ant-design/icons';
import type { MenuDataItem, Settings as LayoutSettings } from '@ant-design/pro-components';
import { PageLoading, SettingDrawer } from '@ant-design/pro-components';
import { ThemeProvider } from '@/context/ThemeContext';
import {
  history,
  Link,
  RequestConfig,
  type RunTimeLayoutConfig,
  request as umiRequest,
} from '@umijs/max';
import React from 'react';
// import {PageEnum} from './enums/pagesEnums';
import { AvatarDropdown, AvatarName, Footer, Question, SelectLang } from '@/components';
import { currentUser as queryCurrentUser, refreshToken } from '@/services/ant-design-pro/api';
import defaultSettings from '../config/defaultSettings';
import { errorConfig } from './requestErrorConfig';
import {
  clearSessionToken,
  getAccessToken,
  getRefreshToken,
  getTokenExpireTime, setSessionToken,
} from './access';
import { Badge, message } from "antd";
import { dictAll } from './dict'
import { getNoReadCount } from "@/pages/admin/enquiry/types";
const isDev = process.env.NODE_ENV === 'development' || process.env.CI;
const loginPath = '/website/index';


// // 🌟 Umi 官方规范：通过此函数包裹，可以让全项目共享主题切换的能力
// export function rootContainer(container: React.ReactNode) {
//   return (
//     <ThemeProvider>
//       {container}
//     </ThemeProvider>
//   );
// }


/**
 * @see https://umijs.org/docs/api/runtime-config#getinitialstate
 * */
export async function getInitialState(): Promise<{
  settings?: Partial<LayoutSettings>;
  currentUser?: API.CurrentUser;
  loading?: boolean;
  fetchUserInfo?: () => Promise<API.CurrentUser | undefined>;
  unreadMap: any
}> {
  let unreadCounts = { enquiryList: 0, rv2goOrder: 0 };
  try {
    const token = getAccessToken();
    if (token) {
      console.log("----获取未读数----")
      // 2. 调用接口获取数据，假设接口返回: { success: true, data: { enquiryList: 5, rv2goOrder: 0 } }
      const res = await getNoReadCount();
      console.log("----未读数----", res)
      if (res?.code == 0) {
        unreadCounts.enquiryList = res?.data ?? 0;
      }
    }
  } catch (error) {
    console.error('获取未读数失败：', error);
  }



  const fetchUserInfo = async () => {
    try {
      const msg = await queryCurrentUser({
        skipErrorHandler: true,
      });
      return msg.data.user;
    } catch (_error) {
      history.push(loginPath);
    }
    return undefined;
  };
  // 如果不是登录页面，执行
  const { location } = history;

  if (
    ![loginPath, '/user/register', '/user/register-result'].includes(
      location.pathname,
    )
  ) {
    if (location.pathname.startsWith('/website/')) {
      history.push(location.pathname);

    } else {
      console.log("ddddd-assss")
      const currentUser = await fetchUserInfo();
      return {
        fetchUserInfo,
        currentUser,
        settings: defaultSettings as Partial<LayoutSettings>,
        unreadMap: unreadCounts
      };
    }

  }
  return {
    fetchUserInfo,
    settings: defaultSettings as Partial<LayoutSettings>,
     unreadMap: unreadCounts
  };
}




// ProLayout 支持的api https://procomponents.ant.design/components/layout
export const layout: RunTimeLayoutConfig = ({
  initialState,
  setInitialState,
}) => {
  return {
    actionsRender: () => [
      // <Question key="doc" />,
      <SelectLang key="SelectLang" />,
    ],
    avatarProps: {
      src: initialState?.currentUser?.avatar,
      title: <AvatarName />,
      render: (_, avatarChildren) => {
        return <AvatarDropdown>{avatarChildren}</AvatarDropdown>;
      },
    },
    // waterMarkProps: {
    //   content: initialState?.currentUser?.name,
    // },

    footerRender: () => <Footer />,
    onPageChange: () => {

      const { location } = history;

      console.log("onPageChange  location", location)
      // 如果没有登录，重定向到 login
      if (!initialState?.currentUser && location.pathname !== loginPath) {
        history.push(loginPath);
      }
    },
    bgLayoutImgList: [
      {
        src: 'https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/D2LWSqNny4sAAAAAAAAAAAAAFl94AQBr',
        left: 85,
        bottom: 100,
        height: '303px',
      },
      {
        src: 'https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/C2TWRpJpiC0AAAAAAAAAAAAAFl94AQBr',
        bottom: -68,
        right: -45,
        height: '303px',
      },
      {
        src: 'https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/F6vSTbj8KpYAAAAAAAAAAAAAFl94AQBr',
        bottom: 0,
        left: 0,
        width: '331px',
      },
    ],
    links: isDev
      ? [
        <Link key="openapi" to="/umi/plugin/openapi" target="_blank">
          <LinkOutlined />
          <span>OpenAPI 文档</span>
        </Link>,
      ]
      : [],
    menuHeaderRender: undefined,
    subMenuItemRender: (menuItemProps: MenuDataItem, defaultDom: React.ReactNode) => {
      // 模拟子菜单未读数

      const noticeCount = initialState?.unreadMap.enquiryList || 0;


      // 如果当前渲染的是「询价管理」父菜单
      if (menuItemProps.path === '/enquiry') {
        return (
          <Link to={menuItemProps.path} style={{ display: 'flex', alignItems: 'center' }}>
            {/* 1. 先渲染原生的菜单图标 */}
            {menuItemProps.pro_layout_parentKeys?.length === 0 && menuItemProps.icon}
            {/* 2. 用样式撑开距离，并只在文字上加 Badge，设置 offset 移到右上方 */}
            <span style={{ paddingRight: '22px' }}>
              <Badge count={noticeCount} offset={[20, 8]}>
                <span className="ant-pro-menu-item-title">{menuItemProps.name}</span>
              </Badge>
            </span>
          </Link>
        );
      }

      // 其他普通父菜单默认渲染
      return defaultDom;
    },
    menuItemRender: (menuItemProps: MenuDataItem, defaultDom: React.ReactNode) => {

      if (menuItemProps.isUrl || !menuItemProps.path) {
        return defaultDom;
      }
      const showDotPaths = ['/enquiry', '/enquiry/list'];
      const noticeCount = initialState?.unreadMap.enquiryList || 0;
      // 2. 根据路径匹配，动态包裹 Badge 组件
      const currentPath = menuItemProps.path;
      // console.log(menuItemProps)
      if (showDotPaths.includes(menuItemProps.path)) {
        return (
          <Link to={menuItemProps.path} style={{ display: 'flex', alignItems: 'center' }}>
            {/* 1. 先渲染原生的菜单图标 */}
            {menuItemProps.pro_layout_parentKeys?.length === 0 && menuItemProps.icon}

            {/* 2. 用样式撑开距离，并只在文字上加 Badge，设置 offset 移到右上方 */}
            <span style={{ paddingRight: '12px' }}>
              <Badge count={noticeCount} offset={[20, 8]}>
                <span className="ant-pro-menu-item-title">{menuItemProps.name}</span>
              </Badge>
            </span>
          </Link>
        );
      }

      // 如果当前渲染的是「询价管理」父菜单，且子菜单有未读
      if (currentPath === '/enquiry') {
        return (
          <Link to={currentPath} style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
            <span style={{ position: 'relative', display: 'inline-block', paddingRight: '14px' }}>
              {menuItemProps.name}
              {/* 父菜单展示为：正圆角小红点 */}
              <Badge
                dot
                offset={[10, -4]}
                style={{ position: 'absolute' }}
              />
            </span>
          </Link>
        );
      }

      return <Link to={menuItemProps.path}>{defaultDom}</Link>;
    },
    // 自定义 403 页面
    // unAccessible: <div>unAccessible</div>,
    // 增加一个 loading 的状态
    childrenRender: (children) => {
      if (initialState?.loading) return <PageLoading />;
      return (
        <>
          {children}
          <SettingDrawer
            disableUrlParams
            enableDarkTheme
            settings={initialState?.settings}
            collapse={initialState?.settingDrawerOpen}
            onCollapseChange={(open) => {
              setInitialState((s) => ({
                ...s,
                settingDrawerOpen: open,
              }));
            }}
            onSettingChange={(settings) => {
              setInitialState((preInitialState) => ({
                ...preInitialState,
                settings,
              }));
            }}
          />
        </>
      );
    },
    ...initialState?.settings,
  };
};
// export async function onRouteChange({ clientRoutes, location }) {
//   const menus = getRemoteMenu();
//   // console.log('onRouteChange', clientRoutes, location, menus);
//   // if (menus === null && location.pathname !== PageEnum.LOGIN) {
//   //   console.log('refresh');
//   //   history.go(0);
//   // }
// }
//
// // export function patchRoutes({ routes, routeComponents }) {
// //   console.log('patchRoutes', routes, routeComponents);
// // }
//
// export async function patchClientRoutes({ routes }) {
//   console.log('patchClientRoutes123', routes);
//   patchRouteWithRemoteMenus(routes);
// }
//
// export function render(oldRender: () => void) {
//   // console.log('render get routers', oldRender)
//   const token = getAccessToken();
//   if (!token || token?.length === 0) {
//     oldRender();
//     return;
//   }
//   getRoutersInfo().then((res) => {
//     setRemoteMenu(res);
//     oldRender();
//   });
// }

const checkRegion = 5 * 60 * 1000;

// 1. 定义全局状态和队列
let isRefreshing = false; // 标记是否正在刷新 Token
let requestsQueue: any[] = []; // 存储因 401 被挂起的请求队列

// 将请求加入队列的函数
const subscribeTokenRefresh = (cb: (token: string) => void) => {
  requestsQueue.push(cb);
};

// 刷新成功后，遍历执行队列中的请求
const onRefreshed = (token: string) => {
  requestsQueue.map((cb) => cb(token));
  requestsQueue = [];
};

/**
 * @name request 配置，可以配置错误处理
 * 它基于 axios 和 ahooks 的 useRequest 提供了一套统一的网络请求和错误处理方案。
 * @doc https://umijs.org/docs/max/request#配置
 */
export const request: RequestConfig = {
  // 请求拦截器：正常携带 Token
  requestInterceptors: [
    (config: any) => {
      const token = getAccessToken();
      if (token && config.headers) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
      /// 前端的登录模式 token
      const appToken = localStorage.getItem("app_token")
      if (appToken && config.headers) {
        config.headers['satoken'] = `${appToken}`;
      }
      return config;
    },
  ],
  responseInterceptors: [
    (response) => response,
    async (error: any) => {
      // // 不再需要异步处理读取返回体内容，可直接在data中读出，部分字段可在 config 中找到
      const { data = {} as any } = error;
      // // do something
      const config = error?.config;


      const { location } = history;

      // 核心修正：如果是登录接口报错，直接抛出错误，绝对不走无感刷新和重定向逻辑
      if (config?.url?.includes('/system/auth/login')) {
        console.log("intercept", error)
        return Promise.resolve(error);
      }

      if (data.code == 401) {
        if (isRefreshing && config) {
          return new Promise((resolve) => {
            subscribeTokenRefresh((newToken: string) => {
              // 用最新的 token 替换掉旧的 header
              config.headers['Authorization'] = `Bearer ${newToken}`;
              // 2. 核心修正：使用引入的 umiRequest 重新发起请求
              return resolve(umiRequest(config.url!, config));
            });
          })
        }
        // 4. 只有第一个 401 请求会走到这里，开启刷新锁
        isRefreshing = true;
        try {
          const refreshToken1 = getRefreshToken();
          if (refreshToken1) {
            refreshToken(refreshToken1!).then((result) => {
              let at = result.data
              if (result.code == 400) {
                if (location?.pathname?.includes('/website/')) {
                  history.push(location.pathname);
                  return Promise.resolve(error);
                } else {
                  isRefreshing = false;
                  requestsQueue = []; // 清空队列
                  clearSessionToken()
                  history.push(loginPath);
                }
              }
              if (result.code != 0) {
                return Promise.resolve(error);
              }
              console.log("ac", result)
              setSessionToken(at.accessToken, at.refreshToken, at.expireTime);
              localStorage.removeItem("isRefreshing");
              let newToken = at.accessToken
              // 执行队列中被挂起的请求
              onRefreshed(newToken);
              // 释放锁
              isRefreshing = false;

              config['Authorization'] = `Bearer ${newToken}`;
              // 3. 核心修正：使用引入的 umiRequest 重新发起当前请求
              return umiRequest(config.url!, config);
            })
          } else {
            if (location.pathname.includes('/website/')) {
              history.push(location.pathname);
              return Promise.resolve(error);
            } else {
              isRefreshing = false;
              requestsQueue = []; // 清空队列
              clearSessionToken()
              history.push(loginPath);
            }
            return Promise.reject(error);
          }

        } catch (e) {
          // 5. 刷新接口也失效了，或者没有 refresh_token
          isRefreshing = false;
          requestsQueue = []; // 清空队列
          clearSessionToken()
          history.push(loginPath);
          return Promise.reject(e);
        }

      } else if (data.code != 200 && data.code != 0) {
        message.error(data.msg);
      }
      return error;
    },
  ],
};
